import React from 'react';

const BellIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 6.66797C5 5.34189 5.52678 4.07012 6.46447 3.13243C7.40215 2.19475 8.67392 1.66797 10 1.66797C11.3261 1.66797 12.5979 2.19475 13.5355 3.13243C14.4732 4.07012 15 5.34189 15 6.66797C15 12.5013 17.5 14.168 17.5 14.168H2.5C2.5 14.168 5 12.5013 5 6.66797Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.58203 17.5C8.72152 17.7537 8.92657 17.9653 9.17577 18.1127C9.42498 18.26 9.70918 18.3378 9.9987 18.3378C10.2882 18.3378 10.5724 18.26 10.8216 18.1127C11.0708 17.9653 11.2759 17.7537 11.4154 17.5"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BellIcon;
